import React from 'react';

import { useState } from 'react';
import { useEffect } from 'react';
import {
    getemployees
} from "../dbconnector/connector";



const EmployeeSelection = ({ isDisabled, data, valueneeded, cssclass, employeelist }) => {
    const [employees, setEmployees] = useState([]);

    useEffect(() => {
     loademployees()
    }, []);
    function loademployees()
    {
//console.log("employeelist :" , employeelist)
           try {
            if (employeelist.length ===0) {

                const Employees = getemployees();
                Employees.then((list) => {
                    if (list.status === 200) {
                        //console.log("eeeeeeeeeeeeeeeeeeee", list.items)
                        setEmployees(list.items)
                        //Createhotelslist(hotellist.items, navigate);

                        let listForEmployees = document.getElementById("employeeList");
                        if (listForEmployees === null) {
                            listForEmployees = document.createElement("select");
                            listForEmployees.id = "hotelsList";

                        } else {
                            listForEmployees.innerHTML = ""
                        }

                        const defaultOption = document.createElement("option");
                        defaultOption.value = -1;
                        defaultOption.innerText = " - selecteer werknemer -"
                        listForEmployees.appendChild(defaultOption)

                        list.items.forEach((employee, index) => {
                            const empOption = document.createElement("option");
                            empOption.value = employee.id;
                            empOption.innerText = employee.nr_wkn + " - " + employee.achternaam + ", " + employee.voornaam
                            listForEmployees.appendChild(empOption)
                        });
                        //if(data !== undefined)
                        //    listForEmployees.value = data.selectedemployee
                    } else {
                        //setErrorMessage("Error while retrieving hotels")
                    }
                })
            }
        } catch (error) {
            //setErrorMessage("Error while retrieving hotels")
        }
    }

    useEffect(() => {
        console.log("employeelist" , employeelist)
        if (employeelist !== undefined && employeelist.length > 0) {
            try {
                let listForEmployees = document.getElementById("employeeList");
                listForEmployees.innerHTML = ""
                setEmployees([])
                //console.log("aaaaaaaaaaaaa", employeelist)
                setEmployees(employeelist)
                const defaultOption = document.createElement("option");
                defaultOption.value = -1;
                defaultOption.innerText = "- selecteer werknemer -"
                listForEmployees.appendChild(defaultOption)
                employeelist.forEach((employee) => {
                    //console.log("employee", employee)
                    const empOption = document.createElement("option");
                    empOption.value = employee.id;
                    empOption.innerText = employee.achternaam + ", " + employee.voornaam
                    listForEmployees.appendChild(empOption)

                })
            } catch (error) {
                //setErrorMessage("Error while retrieving hotels")
            }
        }else{
            loademployees()
        }
    }, [employeelist]);


    

    return (

        <select id="employeeList" disabled={isDisabled} className={cssclass} value={data.selectedemployee !== null ? data.selectedemployee : null} onChange={data !== null ? data.handleitemchange : null} name={data.fieldname !== null ? data.fieldname : undefined} >
            <option>- selecteer werknemer -</option>
        </select>
    );
}


export default EmployeeSelection;
